
const React = require('react');
const { default: Layout} = require('./src/components/layout');
const { ComparisionProvider } = require('./src/components/comparision-context');
const { ThemeProvider } = require("./src/components/theme-toggle");
const { TranslateProvider } = require("./src/components/translate");

exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

exports.wrapRootElement = ({ element }) =>  (
  <TranslateProvider>
    <ComparisionProvider>
      <ThemeProvider>
        {element}
      </ThemeProvider>
    </ComparisionProvider>
  </TranslateProvider>
);